import { Progress as AntProgress } from "antd";

const Progress = AntProgress;

export default Progress;
